import {Injectable} from '@angular/core';

@Injectable()
export class WindowProtectorProvider {

  private readonly handleFocus: () => void;
  private readonly handleBlur: () => void;

  constructor() {
    this.handleFocus = this.onFocus.bind(this);
    this.handleBlur = this.onBlur.bind(this);
  }

  public start(): void {
    window.addEventListener('focus', this.handleFocus);
    window.addEventListener('blur', this.handleBlur);
  }

  public stop(): void {
    window.removeEventListener('focus', this.handleFocus);
    window.removeEventListener('blur', this.handleBlur);
  }

  private onFocus(): void {
    document.body.style.display = 'block';
  }

  private onBlur(): void {
    document.body.style.display = 'none';
  }

}



// WEBPACK FOOTER //
// ./src/providers/window-protector/window-protector.ts